import 'css-chunksrc/client/common/quickAllocationMenu/styles.scss';export default {
  "quickAllocationMenu": "_quickAllocationMenu_myjva_1",
  "resourcesList": "_resourcesList_myjva_10",
  "item": "_item_myjva_14",
  "search": "_search_myjva_22"
};